import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageParts';
import { MASTER_CONFIGS } from '../config/mastersConfig';
import { Landmark, Truck, Fuel } from 'lucide-react';

const EXTRA_CARDS = [
  { to: '/centros-custo', title: 'Centros de Custo', description: 'Estrutura financeira', icon: Landmark },
  { to: '/cadastros/fornecedores', title: 'Fornecedores', description: 'Cadastro completo com endereço e financeiro', icon: Truck },
  { to: '/cadastros/modelos-veiculos', title: 'Modelos de Veículos', description: 'Vinculados às marcas', icon: Truck },
  { to: '/cadastros/postos-combustivel', title: 'Postos de Combustível', description: 'Vinculados a fornecedores', icon: Fuel },
];

export default function MastersIndex() {
  return (
    <div>
      <PageHeader title="Cadastros Mestres" subtitle="Base de dados que alimenta os módulos operacionais" />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {EXTRA_CARDS.map(c => (
          <Link key={c.to} to={c.to} className="card-hover block rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-5">
            <div className="h-10 w-10 rounded-lg bg-red-50 dark:bg-red-950/30 text-brand flex items-center justify-center mb-3">
              <c.icon className="h-5 w-5" />
            </div>
            <p className="font-semibold">{c.title}</p>
            <p className="text-xs text-neutral-500 mt-0.5">{c.description}</p>
          </Link>
        ))}
        {Object.entries(MASTER_CONFIGS).map(([key, cfg]) => (
          <Link key={key} to={`/cadastros/${key}`} className="card-hover block rounded-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 p-5">
            <div className="h-10 w-10 rounded-lg bg-red-50 dark:bg-red-950/30 text-brand flex items-center justify-center mb-3">
              <cfg.icon className="h-5 w-5" />
            </div>
            <p className="font-semibold">{cfg.title}</p>
            <p className="text-xs text-neutral-500 mt-0.5">{cfg.subtitle}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
